import { Component, ViewChild } from '@angular/core';
import { NavRoutes } from '../../../constants/nav.routes';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { HighlightDirective } from '../../../../shared/directives/highlight.directive';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FooterComponent } from '../../footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-public-main',
  templateUrl: './public-main.component.html',
  styleUrls: ['./public-main.component.scss'],
  standalone: true,
  imports: 
  [
    CommonModule,
    FlexModule, 
    RouterLink, 
    RouterOutlet, 

    MatToolbarModule, 
    MatButtonModule, 
    MatIconModule, 
    MatSidenavModule, 
    MatListModule, 

    HighlightDirective, 

    FooterComponent, 
  ]
})
export class PublicMainComponent extends BaseComponent {

  readonly routes = NavRoutes;
  screenWidth: number;
  screenHeight: number;
  @ViewChild(MatSidenav, { static: true }) sidenav: MatSidenav;

  constructor() {
    super();
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }

  toggleSideNav() {
    this.sidenav.opened ? this.sidenav.close() : this.sidenav.open();
  }

  shouldPlaceBottomPage(): boolean {
    return this.screenHeight > 408;
  }
}